export const LABELS = {
  noAssignees: 'Assignee',
  assignees: 'Assignees',
  noLabels: 'Label',
  labels: 'Labels',
  noProjects: 'Project',
  noMilestones: 'Milestone',
  noIssueTypes: 'Issue Type',
  filterOrganizations: 'Filter organizations',
  organizationLabel: 'Organization',
  selectAssignees: 'Select assignees',
  selectMilestones: 'Select milestone',
  selectIssueTypes: 'Select issue type',
  selectProjects: 'Select projects',
  selectLabels: 'selectLabels',
  selectRepository: 'Select repository',
  selectBranch: 'Select a branch',
  selectPr: 'Select a pull request',
  searchPr: 'Search pull requests',
  maxPRsLinkingWarning: 'You may only link 10 pull requests to this issue across all repositories.',
  filterUsers: 'Filter users',
  filterMilestones: 'Filter milestones',
  filterIssueTypes: 'Filter issue types',
  filterProjects: 'Filter projects',
  getNumberOfSelectedPrsLabel: (count: number) =>
    count === 1 ? `${count} pull request selected` : `${count} pull requests selected`,
}
